import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { LoggerService } from './logger.service';
import { PusherService } from './pusher.service';

import * as RootActions from '../../state/root.actions';
import { PresenceChannel } from 'pusher-js';
import { BaseUser } from '../models/base-user.model';

const GLOBAL_PRESENCE = 'presence-global';

@Injectable({
  providedIn: 'root',
})
export class GlobalPresenceService {
  channel: PresenceChannel;

  constructor(
    private logger: LoggerService,
    private pusher: PusherService,
    private store$: Store
  ) {}

  public subscribe() {
    console.log('subscribe global presence');
    this.channel = this.pusher.subscribe(GLOBAL_PRESENCE);

    this.pusher.bindChannelEvent(
      this.channel,
      'pusher:subscription_succeeded',
      (members) => {
        this.logger.info(
          'Global presence channel subscription succeeded: ' + this.channel.name
        );
        this.logger.info('Global presence members: ' + members.count);
        let users: BaseUser[] = Object.entries(members.members).map(
          (info: any) => info[1]
        );
        this.store$.dispatch(
          RootActions.subscribeGlobalChannelSuccess({
            channelName: GLOBAL_PRESENCE,
          })
        );
        this.store$.dispatch(RootActions.setGlobalUsers({ users }));
      }
    );

    this.pusher.bindChannelEvent(
      this.channel,
      'pusher:subscription_error',
      (status) => {
        this.logger.error(
          'Global presence channel subscription FAILED: ' + this.channel.name
        );
        this.logger.error(status);
      }
    );

    this.pusher.bindChannelEvent(
      this.channel,
      'pusher:member_added',
      (member) =>
        this.store$.dispatch(RootActions.globalUserOnline(member.info))
    );
    this.pusher.bindChannelEvent(
      this.channel,
      'pusher:member_removed',
      (member) =>
        this.store$.dispatch(RootActions.globalUserOffline(member.info))
    );

    this.pusher.bindChannelEvent(
      this.channel,
      'conferencing:call_request',
      this.handleCallRequest
    );
  }

  public unsubscribe() {
    this.pusher.unsubscribe(GLOBAL_PRESENCE);
    this.logger.info('Unsubscribed global presence channel');
  }

  private handleCallRequest(data: any) {
    this.logger.info('Call request data received: ${data}');
  }
}
